module.exports = "/_next/static/images/img-hero-origin-69d401af3e4c6bbc081929251e392991.svg";